var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chevron-right_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.626 8.39c5.281 11.676 9.823 20.118 15.92 23.864 0 0-.014 0-.028.015h.028c-6.03 3.682-10.5 12.002-15.664 23.516l23.57-23.57z"
  })));
};
export { SvgChevronRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTguNjI1NiA4LjM4OTE2QzIzLjkwNzQgMjAuMDY2MiAyOC40NDkzIDI4LjUwODIgMzQuNTQ2MyAzMi4yNTQzQzM0LjU0NjMgMzIuMjU0MyAzNC41MzIxIDMyLjI1NDMgMzQuNTE3OCAzMi4yNjg2TDM0LjU0NjEgMzIuMjY4N0MyOC41MTU5IDM1Ljk1MTQgMjQuMDQ1NyA0NC4yNzA2IDE4Ljg4MTggNTUuNzg0OUw0Mi40NTE2IDMyLjIxNTFMMTguNjI1NiA4LjM4OTE2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";